import { computed, makeObservable } from "mobx";
import { BaseSyncModel } from "@/store/sync/BaseSyncModel";
import { SyncModelKind } from "@/store/sync/types";
import { WithAppStore } from "@/store/types";
import { SessionModelData } from "./types";
import { SyncUpdateValue } from "@/store/sync/types";

export class SessionObservable extends BaseSyncModel<SessionModelData> {
  public modelKind = SyncModelKind.Session;

  constructor({
    id,
    data,
    store,
  }: { id: string; data: SyncUpdateValue<SessionModelData> } & WithAppStore) {
    super({ id, data, store });

    makeObservable(this, {
      lastUserActionAt: true,
      modelKind: false,

      title: computed,
      status: computed,
      kind: computed,
      firstEvent: computed,
      latestEvent: computed,
      firstEventAt: computed,
      latestEventAt: computed,
    });
  }

  get title() {
    return this.modelData.title ?? null;
  }

  get status() {
    return this.modelData.status ?? null;
  }

  get kind() {
    return this.modelData.kind ?? null;
  }

  get lastUserActionAt() {
    return this.modelData.last_user_action_at ?? null;
  }

  get firstEvent() {
    // Prevent accessing sessionEvents during subscription setup to avoid circular dependency
    if (!this.store.sessionEvents.isReady) return undefined;

    return this.store.sessionEvents
      .getSessionEventsBySessionId(this.id)
      .toSorted((a, b) => a.locallyCreatedAt.getTime() - b.locallyCreatedAt.getTime())[0];
  }

  get latestEvent() {
    // Prevent accessing sessionEvents during subscription setup to avoid circular dependency
    if (!this.store.sessionEvents.isReady) return undefined;

    return this.store.sessionEvents
      .getSessionEventsBySessionId(this.id)
      .toSorted((a, b) => b.locallyCreatedAt.getTime() - a.locallyCreatedAt.getTime())[0];
  }

  get firstEventAt() {
    return this.firstEvent?.locallyCreatedAt;
  }

  get latestEventAt() {
    return this.latestEvent?.locallyCreatedAt;
  }
}
